import { Heading } from "@chakra-ui/react"
import React from "react"

type Props = {
  children: string
}

const SpeakerModalHeading = ({ children }: Props) => (
  <Heading fontWeight="semibold" fontSize="3xl">
    {children}
  </Heading>
)

export default SpeakerModalHeading
